import React, { useState, useEffect, useContext } from 'react';
import { Line } from 'react-chartjs-2';
import * as PROJECT_CODE from '../../constants/projectCode';
import { FirebaseContext } from '../../context/firebase';
import dayjs from 'dayjs';
import CountUp from 'react-countup';
import './Chart.css';
import { CardContent, Grid, Paper, Typography } from '@material-ui/core';
import cx from 'classnames';
import styles from './CountCard.css';

function Chart() {
	const { firebase } = useContext(FirebaseContext);
	const [labels, setLabels] = useState([]);
	const [data, setData] = useState([]);
	const [totalSold, setTotalSold] = useState();

	useEffect(() => {
		//getting data for the chart
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
			.orderByChild('available')
			.equalTo('soldout')
			.on('value', (snapshot) => {
				var labelArr = [];
				var dataArr = [];

				var count = 0;
				snapshot.forEach((snap) => {
					var dateSold = snap.val()?.dateSold;
					var lotId = snap.val()?.lotId;
					count++;

					var dateSoldFormatted = dayjs(dateSold).format('YYYY-MM-DD');
					labelArr.push(dateSoldFormatted);
					dataArr.push(count);
				});

				console.log('Data arr: ' + dataArr);
				setLabels(labelArr);
				setData(dataArr);
				setTotalSold(dataArr.length);
			});
	}, []);

	const lineChart = (
		<Line
			data={{
				labels: labels.map((date) => date),
				datasets: [
					{
						data: data.map((lotId) => lotId),
						label: 'Lot sold',
						borderColor: '#3333ff',
						fill: true,
					},
				],
			}}
		/>
	);

	return (
		<>
			<Paper className='count-container'>
				<Grid item className={cx(styles.card)}>
					<CardContent>
						<Typography color='textSecondary' gutterBottom>
							Lots Sold
						</Typography>
						<h1>
							{totalSold && (
								<CountUp
									start={0}
									end={totalSold}
									duration={2.5}
									separator=','
								/>
							)}
						</h1>
					</CardContent>
				</Grid>
			</Paper>
			<div className='chart'>{lineChart}</div>
		</>
	);
}

export default Chart;
